import { ElementRef, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

export type fieldNames = string | string[];

@Injectable({
  providedIn: 'root'
})
export class FocusService {

  constructor(
    private logger: LoggerService
  ) { }

    setFocus(formName: ElementRef,  name: fieldNames) {
      // this.logger.debug('setFocus: type: ', typeof name);
      // this.logger.debug('setFocus; name: ', name);
      if (typeof name === 'string') {
        const ele = formName.nativeElement[name]; // this.aForm.nativeElement[name];
        if (ele) {
          ele.focus();
        }
      } else {
        // this.logger.debug('setFocus: isArray?', Array.isArray(name));
        if(Array.isArray(name)){
          name.forEach(n => {
            // this.logger.debug('setFocus: n', n);
            // let el = this.aForm.nativeElement[n];
            let el = formName.nativeElement[n];
            if(el) {
              el.focus();
            }
          })
        }
      }
    }

}
